// extracted by mini-css-extract-plugin
module.exports = {"slideSkeleton":"styles_slideSkeleton__pnud4","slide":"styles_slide__e2b3s"};